export default __webpack_public_path__ + "static/media/logo-cny.5fa377e5.png";